import { defineComponent } from 'vue';
import LoadingWrapper from '@/presentation/components/shared/loading-wrapper/loading-wrapper.vue';
import AddCustomProductCode from '@/presentation/components/custom-products/add-custom-product/add-custom-product.code';

export default defineComponent({
	components: {
		LoadingWrapper
	},
	setup: () => {
		const code = new AddCustomProductCode();

		return {
			isLoading: code.isLoading,
			customProductButtons: code.customProductButtons,
			selectCustomProductType: code.selectCustomProductType.bind(code)
		};
	}
});
